module.exports = __webpack_public_path__ + "img/+hub_logo_yoko_black_background.b701290.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/+hub_logo_yoko_black_background.svg
// module id = wbtr
// module chunks = 1